export class ApiUtil {
  static deserialize = ({ data }) => {
    return data?.docs
      ? data.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }))
      : data.data();
  };
}
